import { create } from 'zustand';

/**
 * `add-to-watchlist` rewires the entity-row select callback in
 * command-palette.tsx to `addWatchlistEntity` instead of navigating to a
 * dossier. Every other routing (slash commands, question-ask, verb
 * dispatch) is inferred from the query text itself, so this axis exists
 * solely for select-callback branching.
 */
export type PaletteMode = 'default' | 'add-to-watchlist';

interface CommandPaletteState {
  open: boolean;
  mode: PaletteMode;
  setOpen: (v: boolean) => void;
  openWithMode: (mode: PaletteMode) => void;
  close: () => void;
  toggle: () => void;
}

export const useCommandPaletteStore = create<CommandPaletteState>((set) => ({
  open: false,
  mode: 'default',
  setOpen: (open) => set({ open }),
  // Explicit close resets mode so the next ⌘K lands on default browse.
  close: () => set({ open: false, mode: 'default' }),
  toggle: () => set((s) => ({ open: !s.open })),
  openWithMode: (mode) => set({ open: true, mode }),
}));
